<script setup lang="ts">
const uiStore = useUIStore()
const productStoreLocation = 'quickview'
const productStore = useProductStore(productStoreLocation)
function closeQuickviewModal() {
  uiStore.isShowQuickviewModal = false
  uiStore.isQuickviewEditMode = false
  productStore.reset()
}
</script>

<template>
  <Modal
    :show="uiStore.isShowQuickviewModal"
    clear-campaign-on-close
    @close="closeQuickviewModal"
    class="signup-modal__modal"
    data-testid="quickview-modal"
  >
    <Quickview
      :is-edit-mode="uiStore.isQuickviewEditMode"
      :selected-product="productStore.selectedProduct!"
      :productStoreLocation="productStoreLocation"
      @close="closeQuickviewModal"
    />
  </Modal>
</template>

<style></style>
